import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5htvkrgekujqjrtsqm0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About Us', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Industries', href: '#industries' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    { name: 'Executive Search', href: '#services' },
    { name: 'Contract Staffing', href: '#services' },
    { name: 'Permanent Placement', href: '#services' },
    { name: 'RPO Solutions', href: '#services' },
    { name: 'Talent Assessment', href: '#services' }
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
    { icon: 'ri-twitter-x-fill', href: '#', label: 'Twitter' },
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' }
  ];

  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
            src="https://sacnamglobal.com/assets/logo.png"
              alt="Company Logo"
              className="h-12 w-auto mb-4"
            />
            <h3><b>SACNAM GLOBAL</b><br/>
Your Recruitment Partner</h3><br/>
            <p className="text-gray-600 leading-relaxed mb-6">
              Connecting exceptional talent with outstanding opportunities. Your trusted recruitment partner since 2023.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-300 text-gray-600 hover:border-teal-600 hover:text-teal-600 hover:bg-teal-50 transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a
                    href={service.href}
                    className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Contact Us</h4>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start text-gray-600">
                <i className="ri-map-pin-line text-teal-600 mr-2 mt-1 flex-shrink-0"></i>
                <span>Office Address : 278 first floor pocket 2 sector 24 Rohini 110085</span>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-phone-line text-teal-600 mr-2 flex-shrink-0"></i>
                <a href="tel:+91-8810564830" className="hover:text-teal-600 transition-colors">+91-8810564830</a>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-phone-line text-teal-600 mr-2 flex-shrink-0"></i>
                <a href="tel:+91-9910553653" className="hover:text-teal-600 transition-colors">+91 91-9910553653</a>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-mail-line text-teal-600 mr-2 flex-shrink-0"></i>
                <a href="mailto:hr.headsacnamglobal@gmail.com" className="hover:text-teal-600 transition-colors break-all">hr.headsacnamglobal@gmail.com</a>
              </li>
            </ul>

            {/* Newsletter */}
            <div>
              <h5 className="font-semibold text-gray-900 mb-3">Subscribe to Newsletter</h5>
              <form onSubmit={handleSubmit} data-readdy-form id="newsletter-form">
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email"
                    required
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                  />
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                  >
                    <i className="ri-send-plane-fill"></i>
                  </button>
                </div>
                {submitMessage && (
                  <p className={`mt-2 text-sm ${submitMessage.includes('Thank') ? 'text-green-600' : 'text-red-600'}`}>
                    {submitMessage}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © 2024 Recruitment Solutions. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="text-gray-400">•</span>
              <a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                Terms of Service
              </a>
            
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
